import _ from 'lodash';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccordionService {
    private events: any = {
        afterCollapse: [],
        afterExpand: []
    };

    public map: any = null;

    constructor(
    ) { }

    one(event: string, callback: () => void) {
        const list = this.events[event];
        const handler = () => {
            _.remove(list, element => {
                return element === handler;
            });
            callback();
        };
        return list.push(handler);
    }

    onAfterCollapse(item) {
        this.map[item].expanded = false;
        _.forEach(this.events.afterCollapse, callback => callback());
    }
    
    onAfterExpand(item) {
        this.map[item].expanded  = true;
        _.forEach(this.events.afterExpand, callback => callback());
    }

    reset() {
        this.events = {
            afterCollapse: [],
            afterExpand: []
        };
        
        this.map = null;
    }
}
